import { isBigCompanyByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { isGdMerged } from "./gaoding";
import { isBigCompanyByGdVip } from "./gaodingVip";

interface Children {
  name: string;
  seo_id: string;
  filter_id: string;
  children: Array<Children>;
  agg_filter_result_responses?: Array<any>;
}
interface Reuslt {
  children: Array<Children>;
}
interface Filters {
  isFilter: boolean;
  iconType: string;
  optionType: string;
  key: string;
  value: string;
  options: Array<{
    label: string;
    optionLabel: string;
    value: string;
    icon: string;
    seo_id: string;
  }>;
}
interface FilterItem {
  id: string;
  name: string;
  children: Array<FilterItem>;
}
const getChildren = (obj: Children): any => {
  if (obj.children && obj.children.length > 0) {
    return obj.children;
  } else if (
    obj.agg_filter_result_responses &&
    obj.agg_filter_result_responses.length > 0
  ) {
    return obj.agg_filter_result_responses;
  } else {
    return [];
  }
};

/**
 * 根据当前登录用户，判断是否展示特定的筛选器标识  为隐藏
 * @param user
 * @param seo_id
 * @returns
 */
function isShowFilter(user: IUser | null, seo_id: string | null | undefined) {
  if (!seo_id) {
    return true;
  }

  const vips = useAppStore.getState().vips;

  const isBigCompany = isGdMerged(user)
    ? isBigCompanyByGdVip(vips as IGdVip[])
    : isBigCompanyByUser(user);

  if (seo_id.startsWith("only_ka") && !isBigCompany) {
    // only_ka：表示该筛选器只针对ka用户展示, 非ka用户则不展示
    return false;
  } else if (seo_id.startsWith("not_ka") && isBigCompany) {
    // not_ka: 标识只展示给非ka用户
    return false;
  } else {
    return true;
  }
}

/**
 * 根据当前用户会员类型，对筛选器进行过滤
 * not_ka: 标识只展示给非ka用户
 * only_ka：表示该筛选器只针对ka用户展示, 非ka用户则不展示
 * @param filters
 * @param user
 * @returns
 */
export function filterFiltersByUser(
  filters: Filters[] | null | undefined,
  user: IUser
) {
  if (filters?.length) {
    return filters.filter((item) => {
      item.options = item.options.filter((option) => {
        return isShowFilter(user, option?.seo_id);
      });

      return isShowFilter(user, item?.key);
    });
  }

  return [];
}

export const getFilters = (result: Reuslt): Array<Filters> | [] => {
  return [
    ...result?.children?.map((item) => {
      const isImg = getChildren(item).every((item) => item?.preview?.icon?.url);
      return {
        isFilter: true,
        iconType: isImg ? "img" : "iconfont",
        optionType: isImg ? "img" : "text",
        name: item?.name,
        key: item?.seo_id || "",
        value: item?.filter_id,
        // 尺寸因为不需要线上太长所以做了特殊处理，增加一个optionLabel
        options:
          getChildren(item).map((option) => {
            if (item?.seo_id === "resolution") {
              return {
                label: option?.name?.split(" ")?.shift(),
                optionLabel: option?.name,
                value: option?.filter_id,
                icon: option?.preview?.icon?.url || null,
                seo_id: option?.seo_id || "",
              };
            } else {
              return {
                label: option?.name,
                value: option?.filter_id,
                icon: option?.preview?.icon?.url || null,
                seo_id: option?.seo_id || "",
              };
            }
          }) || [],
      };
    }),
  ];
};

export const flatFilters = (
  result: Array<FilterItem>
): Array<FilterItem> | [] => {
  if (!result?.length) {
    return [];
  }
  let flatFilters = [];

  result.forEach((item) => {
    flatFilters = [...flatFilters, ...item.children];
  });

  return flatFilters;
};
